import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Sacado } from '../models/sacado.model';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { CollectionService } from '../collection.service';
import { Util } from '../../../utils/util';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { Router } from '@angular/router';
import { ModalConfirmComponent } from '../../../shared/modal-confirm/modal-confirm.component';

@Component({
	selector: 'app-collection-list',
	templateUrl: './list.component.html',
	styleUrls: ['./list.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CollectionListComponent implements OnInit {

	public dataSource: MatTableDataSource<Sacado>;
	public displayedColumns: Array<string> = ['nome', 'email', 'cpfCnpj', 'others'];
	public list: Sacado[] = [];

	constructor(
		private collectionService: CollectionService,
		private router: Router,
		public dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.getList();
	}

	getList() {
		this.list = [];
		this.collectionService.get().subscribe(data => {
			if (data.Existe) {
				this.list = Util.keysToCamel(data.Retorno) as Sacado[];
				this.dataSource = new MatTableDataSource(this.list);
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	view(cpfCnpj: string) {
		this.router.navigate(['cobranca/detalhes/' + Util.removeMaskCharacters(cpfCnpj) + '/visualizar']);
	}

	edit(cpfCnpj: string) {
		this.router.navigate(['cobranca/editar/' + Util.removeMaskCharacters(cpfCnpj)]);
	}

	delete(cpfCnpj: string) {
		const dialogRef = this.dialog.open(ModalConfirmComponent, {
			width: '350px',
			data: {
				title: 'Atenção !',
				text: 'Tem certeza que deseja excluir? Esta ação não pode ser desfeita!'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.collectionService.delete(cpfCnpj).subscribe(data => {
					if (data.Sucesso) {
						this.getList();
					}
				}, error => {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				});
			}
		});
	}

	applyFilter(event: Event) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();
	}

	emit(sacado: Sacado) {
		this.collectionService.setSacadoToEmit(sacado);
		this.router.navigate(['cobranca/valor-data/novo']);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/collection/list/list.component.ts